import styled from "@emotion/styled";

import { fontSourceSerif4, theme } from "shared/lib/styles";

import { StyledArticleComment } from "scmp-app/components/content/content-action-bar/styles";
import { Figure, StyledFigcaption } from "scmp-app/components/content/content-cover-image/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: contents;

  color: #000000;
`;

export const Content = styled.div`
  grid-area: primary-article;

  ${theme.breakpoints.up("desktop")} {
    min-inline-size: 336px;
    max-inline-size: 464px;
  }
`;

export const StyledEntityLink = styled(EntityLink)``;

export const CoverImageStyledEntityLink = styled(StyledEntityLink)`
  grid-area: primary-article-image-carousel;

  min-inline-size: 0;

  ${theme.breakpoints.up("desktop")} {
    min-inline-size: 592px;
  }
`;

export const HeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 600;
  font-size: 24px;
  font-family: ${fontSourceSerif4};
  line-height: 120%;
  letter-spacing: -2.5%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 28px;
  }
`;

export const LiveTagContainer = styled.div`
  margin-block-end: 8px;

  :empty {
    margin-block-end: 0;
  }
`;

export const SubHeadline = styled.div`
  margin-block-start: 8px;

  color: #5a5a5a;
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontSourceSerif4};
  line-height: 135%;
  letter-spacing: -1%;
`;

export const ActionBar = styled.div`
  margin-block-start: 10px;

  time,
  ${StyledArticleComment} {
    font-size: 11px;
    line-height: 100%;
    letter-spacing: 0%;
  }

  time {
    color: #727272;
  }
`;

export const CoverImage = styled.div`
  block-size: auto;
  /* Cancel the super-splash frame's padding-inline so the image spans the
     full frame width on mobile. */
  margin-inline: calc(-1 * var(--super-splash-frame-padding-inline, 16px));

  overflow: hidden;
  ${Figure} {
    aspect-ratio: 3/2;
  }

  ${StyledFigcaption} {
    display: none;

    ${theme.breakpoints.up("tablet")} {
      display: block;

      line-height: 14px;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    margin-inline: 0;
  }
`;
